import { LoVTab } from '../services/types';

export interface LoVNode {
  name: string;
  tab?: LoVTab;
  subValues: Array<LoVNode>;
}

export class ListOfValues implements LoVNode {
  private readonly empty: LoVNode = { name: 'empty', subValues: [] };

  name = 'root';

  subValues: Array<LoVNode>;

  constructor(root: Array<LoVNode>) {
    this.subValues = root;
  }

  private getNames(node?: LoVNode) {
    return node ? node.subValues.map((value) => ({ name: value.name })) : [];
  }

  private findNode(node: LoVNode, name: string) {
    return node.subValues.find((value) => value.name === name);
  }

  getTypes() {
    return this.getNames(this);
  }

  getTypeNode(type: string) {
    return this.findNode(this, type);
  }

  getSubjectsByType(type: string) {
    return this.getNames(this.getTypeNode(type));
  }

  getSubjectNode(type: string, subject: string) {
    const typeNode = this.getTypeNode(type);
    return typeNode ? this.findNode(typeNode, subject) : this.empty;
  }

  getCategoriesBySubjectAndType(type: string, subject: string) {
    return this.getNames(this.getSubjectNode(type, subject));
  }

  getCategoryNode(type: string, subject: string, category: string) {
    const subjectNode = this.getSubjectNode(type, subject);
    return subjectNode ? this.findNode(subjectNode, category) : this.empty;
  }

  getSubcategoriesByCategorySubjectAndType(type: string, subject: string, category: string) {
    return this.getNames(this.getCategoryNode(type, subject, category));
  }

  getSubcategoryNode(type: string, subject: string, category: string, subcategory: string) {
    const categoryNode = this.getCategoryNode(type, subject, category);
    return categoryNode ? this.findNode(categoryNode, subcategory) : this.empty;
  }
}

export type FilterKeys = {
  number?: string;
  status?: string;
  subject?: string;
  date?: string;
};
